// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"bd6f3793","528":"6a6119b4"}[chunkId] + ".chunk.js";
};